import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { dto_common } from "../../../../classes/dto-common";
import { FORMAT_DECIMAL_VALUE } from "../../../../functions/funtion";
import { F_Fammily } from "../../../../util/config-fonts";
import { CSP } from "../../../../config/config";

function PriceDetail({
  SubTotal,
  Discount,
  ServiceCharge,
  TotalTax,
  DeliveryCharge,
  DeliveryDiscount,
  GrandTotal,
  Clear,
}) {
  const formatCurrencyDisplay = (value) => {
    if (typeof value !== "string") {
      return value;
    }

    const trimmedValue = value.trim();
    if (
      trimmedValue === "" ||
      trimmedValue.toLowerCase() === "free" ||
      !/[0-9]/.test(trimmedValue)
    ) {
      return value;
    }

    const numericValue = trimmedValue.replace(/[^0-9.-]+/g, "");
    if (numericValue === "" || Number.isNaN(Number(numericValue))) {
      return value;
    }

    const prefixMatch = value.match(/^[^0-9-]*/);
    const prefix = prefixMatch ? prefixMatch[0] : "";

    return `${prefix}${FORMAT_DECIMAL_VALUE(2, Number(numericValue), 2)}`;
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "white",
        padding: "2%",
        color: "#333333",
      }}
      className="fadeInUp animated"
      data-wow-duration="300ms"
      data-wow-delay="0ms"
    >
      <div className="pgCartPrice">
        <p
          style={{
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          Sub Total
        </p>
        <p
          style={{
            display:
              Discount === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          Discount
        </p>
        <p
          style={{
            display:
              ServiceCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          Service Charge
        </p>

        <p
          style={{
            display:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? "block"
                  : "none"
                : "block",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
            color:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? " #457856"
                  : ""
                : "",
            fontWeight:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? "bold"
                  : ""
                : "",
          }}
        >
          {DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
            ? CSP === "MK" && dto_common.DineType !== 3
              ? "Free Delivery"
              : "Delivery"
            : "Delivery"}
        </p>

        {CSP === "MKB" &&
          DeliveryDiscount !== dto_StartupPageLoadInfo.Currency + " 0.00" && (
            <p
              style={{
                fontFamily: F_Fammily.Medium,
                fontSize: "13px",
              }}
            >
              Delivery Discount
            </p>
          )}

        <p
          style={{
            display:
              TotalTax === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          Tax
        </p>
        <p
          style={{
            fontFamily: F_Fammily.Medium,
            fontSize: "15px",
          }}
        >
          <strong>Total</strong>
        </p>
      </div>
      <div className="pgCartPrice" style={{ marginTop: "5px" }}>
        <p
          style={{
            display: "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          {formatCurrencyDisplay(SubTotal)}
          {""}
        </p>
        <p
          style={{
            display:
              Discount === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          {formatCurrencyDisplay(Discount)}
        </p>
        <p
          style={{
            display:
              ServiceCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          {formatCurrencyDisplay(ServiceCharge)}
        </p>
        <p
          style={{
            display:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK"
                  ? "block"
                  : "none"
                : "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
            color:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? " #457856"
                  : ""
                : "",
            fontWeight:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? "bold"
                  : ""
                : "",
          }}
        >
          {DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
            ? CSP === "MK" && dto_common.DineType !== 3
              ? "Free"
              : formatCurrencyDisplay(DeliveryCharge)
            : formatCurrencyDisplay(DeliveryCharge)}
        </p>

        {CSP === "MKB" &&
          DeliveryDiscount !== dto_StartupPageLoadInfo.Currency + " 0.00" && (
            <p
              style={{
                textAlign: "right",
                fontFamily: F_Fammily.Medium,
                fontSize: "13px",
              }}
            >
              {formatCurrencyDisplay(DeliveryDiscount)}
            </p>
          )}

        <p
          style={{
            display:
              TotalTax === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          {formatCurrencyDisplay(TotalTax)}
        </p>
        <p
          style={{
            fontFamily: F_Fammily.Medium,
            fontSize: "15px",
          }}
        >
          <strong>{formatCurrencyDisplay(GrandTotal)}</strong>
        </p>
        <button
          style={{
            color: "#ff0000",
            border: 0,
            background: "none",
            fontFamily: F_Fammily.Medium,
            fontSize: "14px",
            cursor: "pointer",
            display: "block",
          }}
          onClick={() => {
            Clear();
          }}
        >
          Clear Cart
        </button>
      </div>
    </div>
  );
}

export default PriceDetail;
